export default __webpack_public_path__ + "static/media/acceptable_active.6d76b9c2.svg";